<template>
<div>
    <file-uploader :compMode="compMode" entite="Company"></file-uploader>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-briefcase"></i> 
        <span v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY">{{ $t('project.company.create.title') }}</span>
        <span v-if="compMode == CRUDMODE.UPDATE">{{ $t('project.company.edit.title') }}</span>
        <span v-if="compMode == CRUDMODE.READ">{{ $t('project.company.view.title') }}</span>

        - {{project.aLaCarte ? $t('project.company.form.aLaCarte') : $t('project.company.form.classique') }}

        <span :class="'companyStatus companyStatus_' + project.companyStatus"></span>

        <div class="entreprise_icons float-right">
          <span v-if="conventionVoteAq" class="entreprise_icon" :title="$t('project.investment.form.history.convention')">CNV</span> <!-- class="fa fa-lg fa-users text-info" -->

          <span v-if="angesQuebecCapitalInvesti" class="entreprise_icon" :title="$t('project.company.form.investment.angesQuebecCapitalInvesti')">AQC</span> <!-- class="fa fa-fw fa-user-circle-o fa-lg text-info" -->
          
          <span v-if="angesQuebecCapitalJuniorInvesti" class="entreprise_icon" :title="$t('project.company.form.investment.angesQuebecCapitalJuniorInvesti')">AQJ</span> <!--  class="fa fa-user-o fa-lg text-info" -->
        </div>
            <toggle-button
        style="margin-left:20px"
          v-model="project.displayInWebsite"
          :sync="true"
          :width="200"
          :height="30"
          :font-size="14"
          :labels="{checked: 'Affiché sur le site web', unchecked: 'Masqué sur le site web'}"
        />

      </div>
      <div class="card-body">

        <errorMessage v-bind:message="error"></errorMessage>

        <form @keyup.enter="createProject">
          
          <div class="row">
             <div class="form-group col-md-6">
              <photo-uploader :compMode="compMode" entite="Project" :fileType="fileType_projectLogo" ref="logoUploader"></photo-uploader>
             </div>
               <div class="form-group col-md-6">
            <photo-uploader :compMode="compMode" entite="Project" :fileType="fileType_projectImage" ref="imageUploader"></photo-uploader>
 </div>
          </div>
         
          <div class="row">
            <div class="form-group col-md-8">
              <label for="nameInput">{{ $t('project.form.name') }}*</label>
              <input maxlength="100" v-model.trim="project.entreprise.name" v-validate="'required'" name="name" type="text" 
              class="form-control" id="nameInput" :data-vv-as="$t('project.form.name')" :placeholder="$t('project.form.name')"  /> 
              <span class="text-danger" v-if="errors.has('name')">{{ errors.first('name') }}</span>
            </div>

            <div class="form-group col-md-2">
                <label for="aLaCarteInput">{{ $t('project.company.form.aLaCarte') }}</label>
                <div class="col-9">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" name="aLaCarte" value="1" class="custom-control-input" id="aLaCarteInput" 
                          v-model="project.aLaCarte" >
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">Oui</span>
                    </label>
                </div>
                <span class="text-danger" v-if="errors.has('aLaCarte')">{{ errors.first('aLaCarte') }}</span>
            </div>
            
            <div class="form-group col-md-2">
                <label for="immigrantInput">{{ $t('project.company.form.logoAq') }}</label>
                <div class="col-9">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" name="logoAq" value="1" class="custom-control-input" id="immigrantInput" 
                          v-model="project.logoAq" >
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">Oui</span>
                    </label>
                </div>
                <span class="text-danger" v-if="errors.has('logoAq')">{{ errors.first('logoAq') }}</span>
            </div>

          </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="introduction">{{ $t('member.form.introduction') }}</label>
                      <ckeditor
                        :editor="editor"
                        v-model.trim="introductionInitialize"
                        name="introduction"
                        id="introduction"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="introduction_en">{{ $t('member.form.introduction_en') }}</label>
                      <ckeditor
                        :editor="editor"
                        v-model.trim="introductionEnInitialize"
                        name="introduction_en"
                        id="introduction_en"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>

<!-- 
          <div class="form-group">
            <label for="descriptionInput">{{ $t('project.form.description') }}</label>
            <textarea v-model.trim="project.description" name="description" type="text" class="form-control" id="descriptionInput" 
              placeholder="Description" ></textarea>
            <span class="text-danger" v-if="errors.has('description')">{{ errors.first('description') }}</span>
          </div> -->

     <div class="row">
                    <div class="form-group col-md-6">
                      <label for="description">{{ $t('project.form.description') }}</label>
                      <ckeditor
                        :editor="editor"
                        v-model.trim="descriptionInitialize"
                        name="description"
                        id="description"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="description_en">{{ $t('project.form.description') + ' (EN)' }}</label>
                      <ckeditor
                        :editor="editor"
                        v-model.trim="descriptionEnInitialize"
                        name="description_en"
                        id="description_en"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </div>


          <div class="row">
            <div class="form-group col-md-3">
              <label for="phoneInput">{{ $t('project.form.phone') }}*</label>
              <input v-model.trim="project.entreprise.phone" v-mask="'(###) ###-####'" v-validate="{ rules: { required : true , regex: phoneRegex() } }" 
                name="phone" type="text" class="form-control" id="phoneInput" placeholder="(999) 999-9999"  />
              <span class="text-danger" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
            </div>
            <div class="form-group col-md-3">
              <label for="faxInput">{{ $t('project.form.fax') }}</label>
              <input v-model.trim="project.entreprise.fax" v-mask="'(###) ###-####'" name="entrepriseFax" type="text" class="form-control" id="faxInput"
                placeholder="(999) 999-9999"  />
              <span class="text-danger" v-if="errors.has('entreprise.fax')">{{ errors.first('entreprise.fax') }}</span>
            </div>
            <div class="form-group col-md-3"> 
                <label for="constitutionDateInput">{{ $t('project.form.constitutionDate') }}</label>
              <!-- <input v-model.trim="project.constitutionDate" v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'" name="constitutionDate" 
                type="text" class="form-control" id="constitutionDateInput" placeholder="DD/MM/YYYY"  /> -->
                 <moment-date-picker v-model="project.constitutionDate"></moment-date-picker>
              <span class="text-danger" v-if="errors.has('constitutionDate')">{{ errors.first('constitutionDate') }}</span>
            </div>

            <div class="form-group col-md-3">
              <label for="companyStageInput">{{ $t('project.company.form.companyStage') }}*</label>
              <input type="hidden" name="projectCompanyStage_validate" v-model="projectCompanyStage_validate" v-validate="'required'" />
              <select v-model="project.companyStage" v-validate="'required'" class="form-control" id="companyStageInput" >
                <option v-for="s in companyStages" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('projectCompanyStage_validate')">{{ $t('validations.required') }}.</span>
            </div>

        </div>

          <div class="row">
          
            <div class="form-group col-md-4">
              <label for="sectorOfActivityInput">{{ $t('project.company.form.sectorOfActivity')  + " (ancien, obsolète)" }}*</label>
              <input type="hidden" name="projectSectors_validate" v-model="projectSectors_validate" v-validate="'required'" />
              <select v-model="project.sectorOfActivity" v-validate="'required'" class="form-control" id="sectorOfActivityInput" >
                <option v-for="s in sectors" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('projectSectors_validate')">{{ $t('validations.required') }}.</span>
            </div>

            <div class="form-group col-md-4">
              <label for="celulleInput">{{ $t('project.company.form.cellule') }}</label>
              <select v-model="project.competencyId" class="form-control" id="celulleInput" >
                <option v-for="s in cellulles" :value="s.id" :key="s.id">{{s.name}}</option>
              </select>
            </div>
            
            <div class="form-group col-md-4">
              <label for="originInput">{{ $t('project.company.form.finances.origin') }}*</label>
              <input type="hidden" name="origin_validate" v-model="origin_validate" v-validate="'required'" />
              <select v-model="project.origin" class="form-control" id="originInput" >
                <option v-for="s in origins" :value="s.item1" :key="s.item1" >{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('origin_validate')">{{ $t('validations.required') }}.</span>
            </div>
          
           </div>
           <div class="row">
                                 <div class="form-group col-md-2">
                      <label
                        for="sector"
                      >{{ $t('investmentOpportunity.form.areaOfActivities')  + " (nouveau)" }}</label>
                        <input
                        type="hidden"
                        name="sector"
                        v-model="project.sectorId"
                      />

                       <select
                        v-model="project.sectorId"
                        class="form-control"
                        id="sector"
                        @change="sectorChange"
                      >
                        <option v-for="s in newSectors" :value="s.id" :key="s.id">{{s.name.french}}</option>
                      </select>
                    </div>

                    <div class="form-group col-md-2" v-if="subSectors.length">
                      <label
                        for="sector"
                      >{{ $t('investmentOpportunity.form.subSector') }}</label>
                        <input
                        type="hidden"
                        name="subSector"
                        v-model="project.subSectorId"
                      />

                       <select
                        v-model="project.subSectorId"
                        class="form-control"
                        id="sector"
                      >
                        <option v-for="s in subSectors" :value="s.id" :key="s.id">{{s.name.french}}</option>
                      </select>
                    </div>

                    <div class="form-group col-md-2">
                      <label
                        for="impactInvestment"
                      >{{ $t('investmentOpportunity.form.impactInvestment') }}</label>
                        <input
                        class="custom-control-input"
                        type="checkbox"
                        name="impactInvestment"
                        v-model="project.impactInvestment"
                      />

                        <label class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="impactInvestment"
                            class="custom-control-input"
                            id="impactInvestment"
                            v-model="project.impactInvestment"
                          />
                          <span class="custom-control-indicator"></span>
                          <span class="custom-control-label">Oui</span>
                        </label>

                    </div>
             </div>

          <div class="row">
          
            <div class="form-group col-md-4">
              <label for="acceleratorIncubatorInput">{{ $t('project.company.form.acceleratorIncubator') }}</label>
              <input v-model.trim="project.acceleratorIncubator" name="acceleratorIncubator" type="text" class="form-control" 
                id="acceleratorIncubatorInput" v-bind:placeholder="$t('project.company.form.acceleratorIncubator')"  />
              <span class="text-danger" v-if="errors.has('acceleratorIncubator')">{{ errors.first('acceleratorIncubator') }}</span>
            </div>

            <div class="form-group col-md-4">
              <label for="statusInput">{{ $t('project.form.status') }}*</label>
              <input type="hidden" name="projectCompanyStatus_validate" v-model="projectCompanyStatus_validate" v-validate="'required'" />
              <select v-model="project.companyStatus" v-validate="'required'" :disabled="!editable" :class="'form-control companyStatus_'+ project.companyStatus" id="statusInput">
                <option :class="'companyStatus_'+ s.item1" v-for="s in companyStatuses" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('projectCompanyStatus_validate')">{{ $t('validations.required') }}.</span>
            </div>
          
            <div class="form-group col-md-4" v-if="project.companyStatus == 0"> 
              <label for="inactifReasonInput">{{ $t('project.form.reasonInactif') }}*</label>
              <input type="hidden" name="projectReasonInactif_validate" v-model="projectReasonInactif_validate" v-validate="'required'" />
              <select v-model="project.reasonInactif" v-validate="'required'" :disabled="!editable" :class="'form-control exitReason_'+ project.reasonInactif" id="inactifReasonInput">
                <option :class="'exitReason_'+ s.item1" v-for="s in reasonsInactif" :value="s.item1" :key="s.item1">{{s.item2}}</option>
              </select>
              <span class="text-danger" v-if="errors.has('projectReasonInactif_validate')">{{ $t('validations.required') }}.</span>
            </div>
          </div>

          <address-component v-bind:address="project.entreprise.address"></address-component>

           <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">{{ $t('member.form.socialTitle') }}</div>
                <div class="card-body">
                  <div class="row">
                      <div class="form-group col-md-3">
                      <label for="website">{{ $t('social.websiteLink') }}</label>
                      <input
                        type="text"
                        id="website"
                        v-model.trim="project.website"
                        name="website"
                        class="form-control"
                      />
                    </div>
                                        <div class="form-group col-md-3">
                      <label for="facebook">{{ $t('social.facebookLink') }}</label>
                      <input
                        type="text"
                        id="facebook"
                        v-model.trim="project.facebook"
                        name="facebook"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="linkedIn">{{ $t('social.linkedInLink') }}</label>
                      <input
                        type="text"
                        id="linkedIn"
                        v-model.trim="project.linkedIn"
                        name="linkedIn"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="twitter">{{ $t('social.twitterLink') }}</label>
                      <input
                        type="text"
                        id="twitter"
                        v-model.trim="project.twitter"
                        name="twitter"
                        class="form-control"
                      />
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
           </div>



          <div class="page-break"></div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  <span>{{ $t('project.company.form.conseil.title') }}</span>
                  
                  <div class="float-right"  v-if="compMode != CRUDMODE.READ">
                    <a href="#person" name="person" @click="addPerson"><span class="fa fa-plus fa-lg"></span></a>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-12">
                      <company-person v-bind:companyPersons="project.companyPersons" ref="companyPerson" v-bind:compMode="compMode"></company-person>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="page-break"></div>

          <company-entrepreneur v-bind:companyEntrepreneurs="project.companyEntrepreneur" :isCompanyPage="true" v-bind:compMode="compMode"></company-entrepreneur>

          <div class="page-break"></div>

          <div class="row">
            <div class="form-group col-md-12">
              <div class="card">
                <div class="card-header">
                  <span>{{ $t('project.company.form.angesRepresentative.title') }}</span>
                  
                  <div class="float-right"  v-if="compMode != CRUDMODE.READ">
                    <a href="#angesrepresentative" name="angesrepresentative" @click="addAngesRepresentative"><span class="fa fa-plus fa-lg"></span></a>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-12">
                     <anges-representative v-bind:companyPersons="project.companyPersons"  ref="angesRepresentative" v-bind:compMode="compMode"></anges-representative>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page-break"></div>

          <div class="row">
            <div class="form-group col-md-12">
                <div class="card">
                  <div class="card-header">
                    {{ $t('project.company.form.council.title') }}
                  </div>
    
                <div class="card-body">
                  
                  <create-firm v-bind:firm="project.accounting" v-bind:compMode="compMode" @firmChanged="accountingFirmChanged"></create-firm>

                  <create-firm v-bind:firm="project.lawyer" v-bind:compMode="compMode" @firmChanged="lawyerFirmChanged"></create-firm>

                  <div class="row">

                    <div class="form-group col-md-3">
                      <label for="companyInput">{{ $t('project.company.form.bank') }}</label>
                        
                        <multiselect v-model="project.bank" id="ajax" open-direction="bottom" 
                            :options="banks" :multiple="false" :searchable="true" :loading="isLoading" 
                            :internal-search="false" :clear-on-select="true" :close-on-select="true" 
                            :options-limit="300" :max-height="600" :show-no-results="false" 
                            :hide-selected="true" :taggable="true" 
                            :placeholder="$t('project.company.form.bank')"
                            :select-label="$t('multiselect.tag-placeholder')"
                            :tag-placeholder="$t('multiselect.tag-placeholder')"
                            @search-change="asyncBankFind" @tag="addTagBank">
                        </multiselect>

                        <span class="text-danger" v-if="errors.has('bank')">{{ errors.first('bank') }}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>       

          <div class="page-break"></div>

          <create-financial-information  v-if="compMode !== CRUDMODE.READ" @addClick="onFinancialAddClick" v-bind:emptyFinancialInformation="emptyFinancialInformation" v-bind:entite="project" v-bind:financial-information="financialInformation"></create-financial-information>

          <financial-information v-bind:financialInformations="historiqueFinancialInformations" v-bind:entite="project" :compMode="compMode"></financial-information>

          <div class="page-break"></div>

          <investmentSummary :entites="investments" v-if="compMode == CRUDMODE.READ"></investmentSummary>
          
          <div class="page-break"></div>

          <exitSummary :entites="exits" v-if="compMode == CRUDMODE.READ"></exitSummary>

          <div class="page-break"></div>

          <shareholder :investments="investments" :exits="exits" v-if="compMode == CRUDMODE.READ" :compMode="compMode"></shareholder>

          <div class="card font-weight-bold text-uppercase bg-warning mb-3" v-if="project.importedFromInvestment && compMode == CRUDMODE.UPDATE">
            <div class="card-body">
              <label class="custom-control custom-checkbox" >
                  <input type="checkbox" name="lead"
                    value="1" class="custom-control-input" id="removeImportedFlag" v-model="project.removeImportedFlag" >
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-label">{{ $t('removeImportedFlag') }}</span>
              </label>
            </div>
          </div>

          <a @click="createProject" v-if="compMode == CRUDMODE.CREATE || compMode == CRUDMODE.COPY" id="addButton" class="btn btn-primary">
            {{ $t('form.create_button') }}
          </a>

          <a @click="editProject" v-if="compMode == CRUDMODE.UPDATE" id="editButton" class="btn btn-primary">
            {{ $t('form.edit_button') }}
          </a>

        </form>
      </div>
    </div>
</div>
</template>

<script>
import {
  ProjectServiceClient,
  CompanyServiceClient,
  EntrepreneurServiceClient,
  InvestmentServiceClient,
  ExitServiceClient,
  CompetencyServiceClient,
  CompanyDto,
  AddressDto,
  EntrepriseDto,
  LocalizableStringDto,
  FinancialInformationDto,
  FirmDto,
  SectorServiceClient,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import ErrorMessage from '../ErrorMessage.vue'
import AddressComponent from '../Address.vue'

import CreateFinancialInformation from './CreateFinancialInfo.vue'
import FinancialInformation from './FinancialInfo.vue'
import CompanyEntrepreneur from './CompanyEntrepreneur.vue'
import CreateFirm from './CreateFirm.vue'
import CompanyPerson from './CompanyPerson.vue'
import AngesRepresentative from './AngesRepresentative.vue'

import CrudMixin from '../../shared/Mixin/CrudMixin'
import moment from 'moment'
import Enum from '../../shared/enum'

import Multiselect from 'vue-multiselect'
import InvestmentSummary from '../Investment/InvestmentSummary'
import ExitSummary from '../Investment/ExitSummary'
import Shareholder from './Shareholder.vue'
import PhotoUploader from '../../shared/components/PhotoUploader.vue'
import {ToggleButton} from 'vue-js-toggle-button'

export default {
  name: 'CreateProjectCompany',
  mixins: [CrudMixin],
  data() {
    let dto = new CompanyDto()

    dto.init({projectType: 1, companyStatus: 1})
    dto.entreprise = new EntrepriseDto()
    dto.entreprise.init({})
    dto.entreprise.address = new AddressDto()
    dto.entreprise.address.init({})
    dto.financialInformations = []
    dto.companyEntrepreneur = []
    dto.accounting = new FirmDto()
    dto.accounting.init({firmType: 1})
    dto.lawyer = new FirmDto()
    dto.lawyer.init({firmType: 2})
    dto.companyPersons = []
    dto.angesRepresentatives = []
    dto.introduction = new LocalizableStringDto()
    dto.description = new LocalizableStringDto()

    let financialInformationDto = new FinancialInformationDto()
    financialInformationDto.init({status: true, creation: moment()})

    return {
      ready: false,
      error: '',
      project: dto,
      projectCopy: null,
      types: [],
      banks: [],
      companyStages: [],
      // deprecated
      sectors: [],
      // new sectors from db
      newSectors: [],
      subSectors: [],
      origins: [],
      edit: false,
      options: [],
      functions: [],
      companyStatuses: [],
      financialInformation: financialInformationDto,
      historiqueFinancialInformations: [],
      isLoading: false,
      investments: [],
      exits: [],
      reasonsInactif: [],
      editable: true,
      cellulles: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'link',
            '|',
            'outdent',
            'indent',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'insertTable',
            '|',
            'blockQuote',
            '|',
            'undo',
            'redo',
            'removeFormat',
          ],
        },
      },
      emptyFinancialInformation: false,
    }
  },
  computed: {
    descriptionInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.project.description.french == null) {
          return ' '
        }
        return this.project.description.french
      },
      // setter
      set: function(newValue) {
        this.project.description.french = newValue
      },
    },
    descriptionEnInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.project.description.english == null) {
          return ' '
        }
        return this.project.description.english
      },
      // setter
      set: function(newValue) {
        this.project.description.english = newValue
      },
    },
    introductionInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.project.introduction.french == null) {
          return ' '
        }
        return this.project.introduction.french
      },
      // setter
      set: function(newValue) {
        this.project.introduction.french = newValue
      },
    },
    introductionEnInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.project.introduction.english == null) {
          return ' '
        }
        return this.project.introduction.english
      },
      // setter
      set: function(newValue) {
        this.project.introduction.english = newValue
      },
    },
    fileType_projectLogo: function() {
      return Enum.FileType.PROJECTLOGO
    },
    fileType_projectImage: function() {
      return Enum.FileType.PROJECTIMAGE
    },
    projectCompanyStage_validate: function() {
      return this.project.companyStage
    },
    projectSectors_validate: function() {
      return this.project.sectorOfActivity
    },
    origin_validate: function() {
      return this.project.origin
    },
    projectCompanyStatus_validate: function() {
      return this.project.companyStatus
    },
    projectReasonInactif_validate: function() {
      if (this.project.companyStatus == 0) return this.project.reasonInactif
      return 'not_required'
    },
    angesQuebecCapitalInvesti: function() {
      if (this.investments == null || this.investments.length == 0) return false
      let values = _.flatMap(this.investments, 'investmentValues')
      return _.some(values, x => x.partner != null && x.partner.plan == 6 && x.partner.angesQuebecCapital)
    },
    angesQuebecCapitalJuniorInvesti: function() {
      if (this.investments == null || this.investments.length == 0) return false
      let values = _.flatMap(this.investments, 'investmentValues')
      return _.some(values, x => x.member != null && x.memberType == 3)
    },
    conventionVoteAq: function() {
      if (this.investments == null || this.investments.length == 0) return false

      let values = _.flatMap(this.investments, 'investmentValues')
      return _.some(values, x => x.conventionVoteAq)
    },
  },
  methods: {
    onFinancialAddClick: function(financialInfo) {
      if (financialInfo == null) {
        this.emptyFinancialInformation = false
      } else {
        this.historiqueFinancialInformations.push(financialInfo)
      }
    },
    addPerson: function() {
      this.$refs.companyPerson.addPerson()
    },
    addAngesRepresentative: function() {
      console.log(this.$refs)
      this.$refs.angesRepresentative.addAngesRepresentative()
    },
    manageProject: function() {
      this.projectCopy = _.cloneDeep(this.project)

      let cleanProject = this.cleanFields(this.project)

      cleanProject.financialInformations = []
      if (this.historiqueFinancialInformations != undefined) {
        cleanProject.financialInformations = this.historiqueFinancialInformations
      }

      if (this.financialInformation != null) {
        cleanProject.financialInformations.push(this.financialInformation)
      }

      if (cleanProject.companyEntrepreneur != null) {
        for (var ix = 0; ix < cleanProject.companyEntrepreneur.length; ix++) {
          if (cleanProject.companyEntrepreneur[ix].entrepreneur != null) {
            cleanProject.companyEntrepreneur[ix].entrepreneurId = cleanProject.companyEntrepreneur[ix].entrepreneur.id
          }
          cleanProject.companyEntrepreneur[ix].company = null
          cleanProject.companyEntrepreneur[ix].entrepreneur = null
        }
      } else {
        cleanProject.companyEntrepreneur = []
      }

      if (cleanProject.companyPersons != null) {
        for (var ix = 0; ix < cleanProject.companyPersons.length; ix++) {
          if (cleanProject.companyPersons[ix].type == 1) {
            cleanProject.companyPersons[ix].associatedUser = null
            cleanProject.companyPersons[ix].name = null
            cleanProject.companyPersons[ix].entrepreneur = null
          } else if (cleanProject.companyPersons[ix].type == 2) {
            cleanProject.companyPersons[ix].member = null
            cleanProject.companyPersons[ix].name = null
            cleanProject.companyPersons[ix].entrepreneur = null
          } else if (cleanProject.companyPersons[ix].type == 3) {
            cleanProject.companyPersons[ix].member = null
            cleanProject.companyPersons[ix].name = null
            cleanProject.companyPersons[ix].associatedUser = null
          } else if (cleanProject.companyPersons[ix].type == 4) {
            cleanProject.companyPersons[ix].member = null
            cleanProject.companyPersons[ix].entrepreneur = null
            cleanProject.companyPersons[ix].associatedUser = null
          }

          if (cleanProject.companyPersons[ix].member != null) {
            cleanProject.companyPersons[ix].memberId = cleanProject.companyPersons[ix].member.id
          }
          if (cleanProject.companyPersons[ix].company != null) {
            cleanProject.companyPersons[ix].companyId = cleanProject.companyPersons[ix].company.id
          }
          if (cleanProject.companyPersons[ix].associatedUser != null) {
            cleanProject.companyPersons[ix].associatedUserId = cleanProject.companyPersons[ix].associatedUser.id
          }
          if (cleanProject.companyPersons[ix].entrepreneur != null) {
            cleanProject.companyPersons[ix].entrepreneurId = cleanProject.companyPersons[ix].entrepreneur.id
          }
          cleanProject.companyPersons[ix].company = null
          cleanProject.companyPersons[ix].member = null
          cleanProject.companyPersons[ix].associatedUser = null
          cleanProject.companyPersons[ix].entrepreneur = null
        }
      } else {
        cleanProject.companyPersons = []
      }

      if (!cleanProject.accounting.company && !cleanProject.accounting.email && !cleanProject.accounting.name) {
        cleanProject.accounting = null
        cleanProject.accountingId = null
      }

      if (!cleanProject.lawyer.company && !cleanProject.lawyer.email && !cleanProject.lawyer.name) {
        cleanProject.lawyer = null
        cleanProject.lawyerId = null
      }

      return cleanProject
    },
    createProject: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this

          if (result && this.ready) {
            let CompanyService = ServiceFactory.create(CompanyServiceClient)

            CompanyService.create(self.manageProject())
              .then(function(res) {
                self.persistFiles(self.$route.params.id)
                self.$refs.logoUploader.persistPhoto(self.$route.params.id)
                self.$refs.imageUploader.persistPhoto(self.$route.params.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('project.property.create.succes'), 'success')
                this.$router.push({path: '/projects'})
              })
              .catch(err => {
                self.project = _.cloneDeep(this.projectCopy)
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editProject: function() {
      this.$validator
        .validateAll()
        .then(result => {
          let self = this
          console.log(this.project.companyPersons)
          if (result && this.ready) {
            let CompanyService = ServiceFactory.create(CompanyServiceClient)

            CompanyService.update(self.manageProject())
              .then(function(res) {
                self.persistFiles(self.$route.params.id)
                self.$refs.logoUploader.persistPhoto(self.$route.params.id)
                self.$refs.imageUploader.persistPhoto(self.$route.params.id)
              })
              .then(res => {
                this.$swal('Succès', this.$t('project.company.edit.succes'), 'success')
                this.$router.push({path: '/projects'})
              })
              .catch(err => {
                self.project = _.cloneDeep(this.projectCopy)
                self.processError(err, self)
              })
          } else {
            console.log(self.errors)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    sectorChange: function() {
      let self = this
      let sectorService = ServiceFactory.create(SectorServiceClient)
      let getSubSectors = sectorService.getSubSector(this.project.sectorId)

      getSubSectors
        .then(res => {
          self.subSectors = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchData: function() {
      let service = ServiceFactory.create(ProjectServiceClient)
      let companyService = ServiceFactory.create(CompanyServiceClient)
      let competencyService = ServiceFactory.create(CompetencyServiceClient)
      let sectorService = ServiceFactory.create(SectorServiceClient)

      let self = this
      let promisseAll

      let getCompanyStage = companyService.getCompanyStage()
      let getCompanySector = companyService.getSectorOfActivity()
      let getOrigin = companyService.getOrigin()

      let getCompanyStatus = service.getCompanyStatus()
      let getReasonInactif = service.getReasonInactif()

      let getCellules = competencyService.getCellules()

      let getSectors = sectorService.getSectors()

      getCompanyStage
        .then(res => {
          self.companyStages = res
        })
        .catch(err => {
          console.log(err)
        })
      getCompanySector
        .then(res => {
          self.sectors = res
        })
        .catch(err => {
          console.log(err)
        })

      getOrigin
        .then(res => {
          self.origins = res
        })
        .catch(err => {
          console.log(err)
        })
      getCompanyStatus
        .then(res => {
          self.companyStatuses = res
        })
        .catch(err => {
          console.log(err)
        })
      getReasonInactif
        .then(res => {
          self.reasonsInactif = res
        })
        .catch(err => {
          console.log(err)
        })
      getCellules
        .then(res => {
          self.cellulles = _.filter(res.items, x => x.name != 'Immobilier')
        })
        .catch(err => {
          console.log(err)
        })
      getSectors
        .then(res => {
          self.newSectors = res
        })
        .catch(err => {
          console.log(err)
        })
      if (this.compMode != Enum.Mode.CREATE) {
        let getProject = companyService.get(this.$route.params.id)
        getProject
          .then(res => {
            self.project = res

            if (res.sectorId != null) {
              let getSubSectors = sectorService.getSubSector(res.sectorId)
              getSubSectors
                .then(res => {
                  self.subSectors = res
                })
                .catch(err => {
                  console.log(err)
                })
            }

            if (self.project.entrepriseAddress === undefined) {
              self.project.entrepriseAddress = new AddressDto()
              self.project.entrepriseAddress.init({})
            }
            if (self.project.financialInformations != null) {
              if (this.compMode != Enum.Mode.READ) {
                self.historiqueFinancialInformations = self._.orderBy(
                  self._.filter(self.project.financialInformations, {status: false}),
                  ['creation'],
                  ['desc']
                )
                let finanRef = self._.find(self.project.financialInformations, {
                  status: true,
                })

                if (finanRef == null) {
                  self.emptyFinancialInformation = true
                } else {
                  self.financialInformation = self._.cloneDeep(finanRef)
                }
              } else {
                self.historiqueFinancialInformations = self.project.financialInformations
              }
            }

            if (self.project.constitutionDate != undefined) {
              self.project.constitutionDate = self.$options.filters.formatDate(self.project.constitutionDate)
            }

            if (self.project.companyEntrepreneur == null) {
              self.project.companyEntrepreneur = []
            }

            if (self.project.companyPersons == null) {
              self.project.companyPersons = []
            } else {
              for (let i = 0; i < self.project.companyPersons.length; i++) {
                self.project.companyPersons[i].type =
                  self.project.companyPersons[i].memberId != null
                    ? 1
                    : self.project.companyPersons[i].associatedUserId != null
                      ? 2
                      : self.project.companyPersons[i].entrepreneurId != null ? 3 : 4
              }
            }

            if (self.project.accounting == null) {
              self.project.accounting = new FirmDto()
              self.project.accounting.init({firmType: 1})
            }

            if (self.project.lawyer == null) {
              self.project.lawyer = new FirmDto()
              self.project.lawyer.init({firmType: 2})
            }

            self.chargerInvestments(self.project.id)

            if (self.compMode == Enum.Mode.READ) {
              self.chargerExits(self.project.id)
            }

            if (self.project.companyStatus == 0 && self.project.reasonInactif != 5) {
              // Commented just for the first phase of the project to correct bad data
              //this.editable = false
            }

            self.checkCopyMode(self.project)
          })
          .catch(err => {
            console.log(err)
          })

        promisseAll = Promise.all([getCompanyStage, getCompanySector, getOrigin, getProject, getReasonInactif, getCellules])
      } else {
        this.project.displayInWebsite = true
        this.emptyFinancialInformation = true
        promisseAll = Promise.all([getCompanyStage, getOrigin, getCompanySector, getReasonInactif, getCellules])
      }

      promisseAll.then(v => {
        self.ready = true
      })
    },
    getOptions: function(search, loading) {
      loading(true)

      let service = ServiceFactory.create(EntrepreneurServiceClient)

      service.getAutocomplete(search).then(resp => {
        this.options = resp
        loading(false)
      })
    },
    addMember: function() {
      if (this.project.members === undefined) {
        this.$set(this.project, 'members', [])
      }
      this.project.members.push(new MemberDto())
    },
    deleteMember: function(index) {
      this.project.members.splice(index, 1)
    },
    accountingFirmChanged: function(firm) {
      this.project.accounting = firm
    },
    lawyerFirmChanged: function(firm) {
      this.project.lawyer = firm
    },
    asyncBankFind: function(search) {
      if (search != '') {
        this.isLoading = true
        let service = ServiceFactory.create(CompanyServiceClient)

        service.getBankAutocomplete(search).then(resp => {
          this.banks = resp
          this.isLoading = false
        })
      }
    },
    addTagBank: function(tag) {
      this.banks.push(tag)
      this.project.bank = tag
    },
    chargerInvestments: function(id) {
      let InvestmentService = ServiceFactory.create(InvestmentServiceClient)
      let self = this

      InvestmentService.getAll(id, undefined, '', 0, 10000)
        .then(res => {
          self.investments = res.items
        })
        .catch(err => {
          console.log(err)
        })
    },

    chargerExits: function(id) {
      let exitService = ServiceFactory.create(ExitServiceClient)
      let self = this

      exitService
        .getAll(id, '', 0, 10000)
        .then(res => {
          self.exits = res.items
        })
        .catch(err => {
          console.log('getall:' + err)
        })
    },
  },
  components: {
    errorMessage: ErrorMessage,
    createFinancialInformation: CreateFinancialInformation,
    FinancialInformation: FinancialInformation,
    CompanyEntrepreneur: CompanyEntrepreneur,
    CreateFirm: CreateFirm,
    CompanyPerson: CompanyPerson,
    AngesRepresentative: AngesRepresentative,
    AddressComponent: AddressComponent,
    Multiselect,
    InvestmentSummary,
    ExitSummary,
    Shareholder,
    ToggleButton,
    'photo-uploader': PhotoUploader,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.btn-primary {
  color: #fff !important;
  cursor: pointer;
}
.entreprise_icons {
  padding-right: 20px;
}
.entreprise_icon {
  border: 1px solid rgba(0,0,0,.125);
  background-color: rgba(0,0,0,.08);
  padding: 4px 8px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/CreateCompany.vue